import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { ScrollView } from "react-native";
import {
  RelayEnvironmentProvider,
  useFragment,
  useRelayEnvironment,
} from "react-relay";

import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { BookNow } from "../BookNow";
import { BookModal_session$key } from "./__generated__/BookModal_session.graphql";

type BookModalProps = {
  sessionRef: BookModal_session$key | null;
  isOpen: boolean;
  onClose: () => void;
  onNavigate?: () => void;
};

export const BookModal = ({
  isOpen,
  onClose,
  onNavigate,
  sessionRef,
}: BookModalProps) => {
  const relayEnvironment = useRelayEnvironment();

  const session = useFragment(BookModalFragmentString, sessionRef);

  const handleNavigate = () => {
    onClose();
    onNavigate?.();
  };

  return (
    <Box>
      <StandardModal
        isOpen={isOpen}
        onClose={onClose}
        content={
          isOpen ? (
            <RelayEnvironmentProvider environment={relayEnvironment}>
              <ScrollView>
                <Box p={6}>
                  <BookNow
                    sessionRef={session ?? null}
                    onNavigate={handleNavigate}
                    title={t`New Booking`}
                  />
                </Box>
              </ScrollView>
            </RelayEnvironmentProvider>
          ) : (
            <></>
          )
        }
        disableContentScroll={true}
      />
    </Box>
  );
};

const BookModalFragmentString = graphql`
  fragment BookModal_session on Session {
    ...BookNow_session
  }
`;
